import React from "react";
import { TableBody, TableCell, TableHead, TableRow, Table } from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

  render() {
    const copData = this.props.copData;
    const selectedSearchValues = this.props.selectedSearchValues;
    const cellStyle = {
      border: '1px solid black',
      padding: '4px',
      fontSize: '12px',
      lineHeight: 1.2
    };

    return (
      <div style={{ marginTop: '0' }}>
        <div style={{ marginTop: '0' }}>
          <h3><center>{selectedSearchValues.factoryName}</center></h3>
          <div></div>
          <h4><center>Cost Of Production - ({moment(selectedSearchValues.startDate).format('DD/MMMM/YYYY')} - {moment(selectedSearchValues.endDate).format('DD/MMMM/YYYY')})</center></h4>
        </div>
        <br></br>
        <div>
          <Table size="small" style={{ borderCollapse: 'collapse', width: '100%', fontSize: '12px', marginTop: "0" }} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell style={cellStyle}></TableCell>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold', textAlign: 'center' }}>Amount</TableCell>
                <TableCell style={cellStyle}></TableCell>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold', textAlign: 'center' }}>Avg</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold' }}>Raw Materials</TableCell>
                <TableCell style={cellStyle}></TableCell>
                <TableCell style={cellStyle}></TableCell>
                <TableCell style={cellStyle}></TableCell>
              </TableRow>

              {copData.filter(x => x.categoryName === "Raw Materials" && x.amount !== 0).map((data, index) => (
                <TableRow key={index}>
                  <TableCell style={{ ...cellStyle, paddingLeft: '5%' }}>{data.accountDescriptionTypeName}</TableCell>
                  <TableCell style={{ ...cellStyle, textAlign: 'right' }}>{data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell style={cellStyle}></TableCell>
                  <TableCell style={{ ...cellStyle, textAlign: 'right' }}>{data.costPerUnit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                </TableRow>
              ))}

              <TableRow>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold' }}>Cost of RM</TableCell>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold', textAlign: 'right' }}>{copData.length === 0 ? "" : copData.totalRawMaterials.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell style={cellStyle}></TableCell>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold', textAlign: 'right' }}>{copData.length === 0 ? "" : copData.rawMaterialsCpu === 0 ? "" : copData.rawMaterialsCpu.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
              </TableRow>

              {copData.filter(x => x.categoryName === "Direct Labour" && x.amount !== 0).map((data, index) => (
                <TableRow key={index}>
                  <TableCell style={{ ...cellStyle, paddingLeft: '5%' }}>{data.accountDescriptionTypeName}</TableCell>
                  <TableCell style={{ ...cellStyle, textAlign: 'right' }}>{data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell style={cellStyle}></TableCell>
                  <TableCell style={{ ...cellStyle, textAlign: 'right' }}>{data.costPerUnit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                </TableRow>
              ))}

              <TableRow>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold' }}>Primary Cost</TableCell>
                <TableCell style={cellStyle}></TableCell>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold', textAlign: 'right' }}>{copData.length === 0 ? "" : copData.primaryCost === 0 ? "" : copData.primaryCost.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold', textAlign: 'right' }}>{copData.length === 0 ? "" : copData.primaryCpu === 0 ? "" : copData.primaryCpu.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold' }}>Additions(Overhead cost)</TableCell>
                <TableCell style={cellStyle}></TableCell>
                <TableCell style={cellStyle}></TableCell>
                <TableCell style={cellStyle}></TableCell>
              </TableRow>

              {copData.filter(x => x.categoryName === "Factory Overheads" && x.amount !== 0).map((data, index) => (
                <TableRow key={index}>
                  <TableCell style={{ ...cellStyle, paddingLeft: '5%' }}>{data.accountDescriptionTypeName}</TableCell>
                  <TableCell style={{ ...cellStyle, textAlign: 'right' }}>{data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell style={cellStyle}></TableCell>
                  <TableCell style={{ ...cellStyle, textAlign: 'right' }}>{data.costPerUnit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                </TableRow>
              ))}

              <TableRow>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold' }}>Total Factory Additions</TableCell>
                <TableCell style={cellStyle}></TableCell>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold', textAlign: 'right' }}>{copData.totalFactoryOverhead.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold', textAlign: 'right' }}>{copData.totalFactoryOverheadCpu.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
              </TableRow>

              {copData.filter(x => x.categoryName === "Factory OverHeads" && x.amount !== 0).map((data, index) => (
                <TableRow key={index}>
                  <TableCell style={{ ...cellStyle, paddingLeft: '5%' }}>{data.accountDescriptionTypeName}</TableCell>
                  <TableCell style={{ ...cellStyle, textAlign: 'right' }}>{data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell style={cellStyle}></TableCell>
                  <TableCell style={{ ...cellStyle, textAlign: 'right' }}>{data.costPerUnit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                </TableRow>
              ))}

              <TableRow>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold' }}>Total Cost Of Production</TableCell>
                <TableCell style={cellStyle}></TableCell>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold', textAlign: 'right' }}>{copData.length !== 0 ? copData.productionCost.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ""}</TableCell>
                <TableCell style={{ ...cellStyle, fontWeight: 'bold', textAlign: 'right' }}>{copData.length === 0 ? "" : copData.productionCostCpu === 0 ? "" : copData.productionCostCpu.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }
}
